import { GTLanguage } from 'gql/types.generated'
import { IntlShape, MessageDescriptor } from 'react-intl'

export const safeFormatMessage = ({
  intl,
  messages,
  key
}: {
  intl: IntlShape
  messages: { [key: string]: MessageDescriptor }
  key: string
}): string => {
  if (messages[key]) {
    return intl.formatMessage(messages[key])
  }

  return key
}

export const sortByTranslation = (
  a: string,
  b: string,
  intl: IntlShape,
  messages: { [key: string]: MessageDescriptor }
): number => {
  const aTranslation = safeFormatMessage({ intl, messages, key: a })
  const bTranslation = safeFormatMessage({ intl, messages, key: b })
  return aTranslation.localeCompare(bTranslation)
}

export const getLabelTranslation = <T extends { text: string; language: GTLanguage }>(
  translation: T[],
  language: GTLanguage
): string => {
  return translation.find((t) => t.language === language)?.text || ''
}
